import {sessionStore} from 'libs/storage/storage';
import {getQuoteItems} from 'actions/checkout/checkout';
import {Action} from 'redux-act';
import {FULFILLED, REJECTED} from 'redux-promise-middleware';
import {switchCart, moveAllItemsToShoppingCart} from 'reducers/hto/htoCart/htoCart';
import {getActiveCartItems, isPaymentsInStore} from 'selectors/cart/cart';

import {COUPON} from 'constants/actions';
import {HTO_SESSION_STORAGE_TITLE} from 'constants/homeTryOn/homeTryOn';
import {takeLatest, call, select, put, takeEvery, putResolve} from 'redux-saga/effects';
import {AxiosError} from 'axios';
import {logWithSentry} from 'libs/sentry/sentry';
import {getPayment} from 'pages/cart/store/actions/cart';

/**
 * Switch the cart by active items
 *
 * @param {string} target - target cart to switch
 */
export function* switchCartSaga() {
    const items = yield select(getActiveCartItems);
    yield putResolve(getQuoteItems(items.map(({id}: {id: string}) => id)));

    const isPayment = yield select(isPaymentsInStore);
    const isMoveToHto = !items[0].productAsHto;

    if (!isPayment && !isMoveToHto) {
        yield put(getPayment());
    }

    yield call([sessionStore, 'set'], HTO_SESSION_STORAGE_TITLE, Number(isMoveToHto));
}

/**
 * Scrolls customer to top of the cart page to focus him on changed cart type(HTO/Shopping)
 */
export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};

/**
 * Update HTO cart data for relevant user
 */
export function* updateHTOCartData() {
    const action = yield call(getQuoteItems);
    yield put(action);
}

/**
 * Handles successful moving items from HTO cart to regular cart
 */
export function* handleProceedingToShoppingCart() {
    yield putResolve(getQuoteItems());
    yield call(scrollToTop);
}

/**
 * Handles rejected moving items from HTO cart to regular cart
 * @param {Action<AxiosError>} payload - action payload
 */
export function* handleFailedProceedingToShoppingCart({payload}: Action<AxiosError>) {
    yield call(logWithSentry, payload, {
        problem: `Move HTO cart item(s) to regular cart failed`,
        details: payload.response?.data?.messages,
    });
}

/**
 * Home Try-On cart saga
 */
export function* homeTryOnCartSaga() {
    yield takeEvery(switchCart, switchCartSaga);
    yield takeLatest(`${COUPON.ADD_COUPON}_FULFILLED`, updateHTOCartData);
    yield takeLatest(`${COUPON.REMOVE_COUPON}_FULFILLED`, updateHTOCartData);
    yield takeLatest(`${moveAllItemsToShoppingCart}_${FULFILLED}`, handleProceedingToShoppingCart);
    yield takeLatest(
        `${moveAllItemsToShoppingCart}_${REJECTED}`,
        handleFailedProceedingToShoppingCart,
    );
}
